<template>
  <div class="navigation">
    <figure class="navigation__pic">
      <img src="/images/common/nav_pic.webp" alt="">
    </figure>

    <nav class="navigation__list">
      <ul class="navigation__list__ul">
        <li><a href="/">トップページ</a></li>
        <li><a href="/concept/">コンセプト</a></li>
        <li><a href="/cuisine/">お料理</a></li>
        <li><a href="/rooms/">お部屋</a></li>
        <li><a href="/spa/">鏡ヶ浦温泉</a></li>
        <li><a href="/facilities/">館内施設</a></li>
        <li><a href="/access/">アクセス</a></li>
        <li><a href="/news/">お知らせ</a></li>
        <li><a href="/faq/">よくあるご質問</a></li>
        <li><a href="https://reserve.489ban.net/client/rokuza/0/plan/availability/room">ご宿泊予約</a></li>
      </ul>

      <ul class="navigation__list__meta">
        <li>
          <a href="/images/pdf/privacy.pdf" target="_blank">プライバシーポリシー
            <svg width="11" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6.143 9 4-4-4-4M10.143 5H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </li>
        <li>
          <a href="/contact/">お問い合わせ
            <svg width="11" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6.143 9 4-4-4-4M10.143 5H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </li>
        <li>
          <a href="https://reserve.489ban.net/client/rokuza/0/booked/login?_ga=2.56667946.1803933193.1782708206-45593248.1778580001">予約確認・変更・キャンセル
          <svg width="11" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6.143 9 4-4-4-4M10.143 5H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </li>
      </ul>
    </nav>
    
  </div>
</template>

<style lang="scss" scoped>
.navigation{
  width: 100%;
  height: calc(100% - var(--reservation-fix-area));
  position: fixed;
  background: module.tone(module.$main, 1);
  display: grid;
  grid-template-columns: auto auto;
  z-index: 999;
  &__pic{
    width: 50%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      clip-path: polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%);
      animation: isClipShow 1000ms module.$ease forwards;
      @keyframes isClipShow {
        0%{
          clip-path: polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%);
        }
        100%{
          clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
        }
      }
    }
  }
  &__list{
    position: absolute;
    inset: 0;
    width: 50%;
    height: 100%;
    @include module.flex();
    align-items: center;
    justify-content: center;
    padding: module.side2x() 0;
    &__ul{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 6.4rem;
      grid-row-gap: 1.2rem;
      li{
        font-size: clamp(1.4rem, 4dvh, 1.72rem);
        opacity: 0;
        @for $i from 1 through 20{
          &:nth-child(#{$i}){
            animation: showListitems 500ms $i*40ms ease-out forwards;
          }
        }
        @keyframes showListitems {
          0%{
            transform: translateY(-50%) rotateX(20deg);
            opacity: 0;
          }
          100%{
            transform: translateY(0%);
            opacity: 1;
          }
        }
        a{
          color: module.$white;
          display: inline-block;
          position: relative;
          &:hover{
            &:before{
              width: 100%;
              right: auto;
              left: 0;
            }
          }
          &:before{
            content: '';
            width: 0;
            height: 1px;
            background: module.$white;
            position: absolute;
            right: 0;
            bottom: .16rem;
            transition: width 200ms module.$ease;
          }
        }
      }
    }
    &__meta{
      position: absolute;
      left: module.side();
      bottom: 2rem;
      font-size: .8rem;
      @include module.flex();
      align-items: center;
      justify-content: flex-start;
      gap: 2rem;
      a{
        color: module.$white;
        @include module.flex();
        align-items: center;
        justify-content: flex-start;
        gap: .32rem;
        &:hover{
          text-decoration: underline;
        }
        svg{
          display: block;
          transform: scale(.8);
        }
      }
    }
  }
}
</style>


<script>
import Btn from './Btn.vue'
export default {
  components: {
    Btn: Btn,
  },
}
</script>
